<template>
  <div>
    <Card>

    </Card>
  </div>
</template>

<script>
export default {
  name: "drillDetail"
}
</script>

<style scoped>

</style>
